import React, {Component} from 'react';
import ClassNames from 'classnames';

class SocialMedia extends Component {
    
    constructor(props) {
        super(props);
    }
    
    
    render() {
        const {titleHead, socials} = this.props.configInformation;
        const teaming = this.props.configInformation.teaming;
        const show = socials.some(x => x.url);
        return (
            <div className="">
                {show &&
                <div>
                    {titleHead && (
                        <h3 dangerouslySetInnerHTML={{__html: titleHead}}/>
                    )}
                    {show ?
                        <div>
                            {/*<li className="infoDetailProOneColumn text-left">*/}
                            {socials.map(({url, socialIcon}, index) => url &&
                                <a
                                    key={index}
                                    className="socialCircle shadow-hover"
                                    href={url ? url : "#"}
                                    target="_blank"
                                    rel="nofollow"
                                >
                                    <span className={ClassNames(socialIcon)}/>
                                </a>
                            )}
                            {/*</li>*/}
                        
                        </div>
                        : <span>No tiene redes sociales</span>
                    }
                </div>
                }
            </div>
        );
    }
    
}

export default SocialMedia;
